/**
 * «+ Заявка» во вкладке «Новый год» (29.10.2026, владелец: «вносим лиды» = заявка без времени — имя, телефон, пожелания).
 * POST /api/ny/leads (routes/ny/leads.ts): строка ложится в lead_inbox с НГ-признаком — «!!!» ставится сам, TG никому не шлём.
 * Бронь потом делается обычной модалкой в сетке. Проверка полей — та же, что на сервере (nyModel.leadError), до отправки.
 */
import { useRef, useState } from "react";
import { api } from "../../api/client";
import { EMPTY_LEAD, leadBody, leadError, type NyLeadForm as Form } from "./nyModel";
import { errText } from "./useNy";
import ny from "./dcNy.module.css";

/** onDone(key) — ключ карточки новой заявки (c<id карточки> или l<id заявки> без телефона-клиента), чтобы её раскрыть. */
export function NyLeadForm({ onDone, onCancel }: { onDone: (key: string) => void; onCancel: () => void }) {
  const [f, setF] = useState<Form>(EMPTY_LEAD);
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const sending = useRef(false);   // синхронный гейт: двойной тап до ререндера не создаст две заявки
  const set = (k: keyof Form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => { setF((p) => ({ ...p, [k]: e.target.value })); setErr(null); };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (sending.current) return;
    const bad = leadError(f);
    if (bad) { setErr(bad); return; }
    sending.current = true; setBusy(true);
    try {
      const r = await api<{ id?: number | null; card_id?: number | null }>("/api/ny/leads", { method: "POST", body: leadBody(f) });
      onDone(r.card_id ? `c${r.card_id}` : `l${r.id ?? ""}`);
    } catch (x) {
      setErr(errText(x, "Не удалось сохранить заявку"));
    } finally { sending.current = false; setBusy(false); }
  };

  return (
    <form className={ny.form} onSubmit={(e) => { void submit(e); }} noValidate>
      <div className={ny.formTitle}>Новая заявка</div>
      <label className={ny.field}><span>Имя *</span>
        <input className={ny.input} value={f.name} onChange={set("name")} maxLength={100} autoComplete="off" autoFocus />
      </label>
      <label className={ny.field}><span>Телефон *</span>
        <input className={ny.input} value={f.phone} onChange={set("phone")} inputMode="tel" type="tel" placeholder="+79…" autoComplete="off" />
      </label>
      <div className={ny.row2}>
        <label className={ny.field}><span>Когда хотят</span>
          <input className={ny.input} value={f.when} onChange={set("when")} maxLength={100} placeholder="31 дек вечером / 2–5 янв" autoComplete="off" />
        </label>
        <label className={ny.field}><span>Человек</span>
          <input className={ny.input} value={f.people} onChange={set("people")} inputMode="numeric" maxLength={3} autoComplete="off" />
        </label>
      </div>
      <label className={ny.field}><span>Пожелания</span>
        <textarea className={ny.input} value={f.wishes} onChange={set("wishes")} maxLength={500} rows={3} placeholder="Что хотят: квест, пакет, дети…" />
      </label>
      <div className={ny.formNote}>НГ-отметка («!!!») ставится сама; заявка видна и во «Лидах». Бронь — обычной модалкой в сетке.</div>
      {err ? <div className={ny.err} role="alert">{err}</div> : null}
      <div className={ny.btns}>
        <button type="button" className={`${ny.btn} ${ny.btnGhost}`} onClick={onCancel} disabled={busy}>Отмена</button>
        <button type="submit" className={ny.btn} disabled={busy}>{busy ? "…" : "Сохранить"}</button>
      </div>
    </form>
  );
}
